export const normalize = (str) =>
  str ? str.normalize("NFD").replace(/[\u0300-\u036f ]/g, "") : "";
